import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alm-chevron-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_f_icon, {
      icon: "chevronright",
      class: _normalizeClass(["clickable", { 'is-expanded': _ctx.isExpanded }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle($event)))
    }, null, 8, ["class"])
  ]))
}